import { get as getContactCenterNumber } from "../repositories/enrollment";

export async function getContactCenter(planId: number): Promise<String> {
  const data: String = await getContactCenterNumber(
    `/plan/${planId}/planContacts/contactCenter`
  );
  return data;
}
